<script setup lang="ts">
interface Props {
  width?: number;
  height?: number;
}

withDefaults(defineProps<Props>(), {
  width: 24,
  height: 24,
});
</script>

<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12"
      cy="12"
      r="8.75"
      stroke-width="2.5"
    />
    <circle
      cx="12"
      cy="12"
      r="5.6"
    />
    <circle
      cx="12"
      cy="12"
      r="1.75"
    />
    <path d="M12 10.25V6.4M13.66 11.46l3.67-1.19M13.03 13.42l2.26 3.11M10.97 13.42l-2.26 3.11M10.34 11.46l-3.67-1.19" />
  </svg>
</template>
